module.exports = "<p>\n  nav-signin works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/nav-signin/nav-signin.component.html
// module id = ./src/app/components/navbar/nav-signin/nav-signin.component.html
// module chunks = main